/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 5/2/2023
 */

const underscoreRoleFormat = (str) => str?.replace(/ROLE_|_/g, " ").trim();
const underscorePermFormat = (str) => str?.replace(/PERM_|_/g, " ").trim();
const firstLetterFormat = (str) => str.charAt(0);

const replaceUnderscoresWithSpaces = (text) => {
  const withoutUnderscores = text.replace(/_/g, " ");
  const words = withoutUnderscores.split(" ");

  const titleCaseWords = words.map((word) => {
    const firstLetter = word.charAt(0).toUpperCase();
    const restOfWord = word.slice(1).toLowerCase();
    return firstLetter + restOfWord;
  });

  return titleCaseWords.join(" ");
};

const applyRemoverWords  = (title, wordsToRemove) => {
  const regex = new RegExp(wordsToRemove);
  return title.split(regex);
};

const validateContact = (contact) => {
  const regex = /^94\d{9}$/;
  return contact && !regex.test(contact);
};

const Helpers = {
  underscoreRoleFormat,
  underscorePermFormat,
  firstLetterFormat,
  replaceUnderscoresWithSpaces,
  applyRemoverWords ,
  validateContact,
};
export default Helpers;
